import {
  SYMBOLOGY_TYPES,
  GEOJSON_GEOMETRIES,
  STYLE_TYPES,
  POINT_TYPES
} from '../../../api/Styles/Styles';

export default [
  {
    name: 'WMS STYLE',
    styleType: STYLE_TYPES.RASTER,
    rasterStyle: {
      opacity: 50
    }
  },
  {
    name: 'TILE STYLE',
    styleType: STYLE_TYPES.RASTER,
    rasterStyle: {
      opacity: 40
    }
  },
  {
    name: 'TMS STYLE',
    styleType: STYLE_TYPES.RASTER,
    rasterStyle: {
      opacity: 30
    }
  },
  {
    name: 'Simple Orange Polygon',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.SINGLE,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      styleData: {
        color: '#ea6512',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'Madrid SouthEast Streets',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.SINGLE,
      geometry: GEOJSON_GEOMETRIES.LINESTRING,
      styleData: {
        color: '#1dea12',
        alpha: 0.9,
        weight: 1
      }
    }
  },
  {
    name: 'Prueba Puntos GeoJSON',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.SINGLE,
      geometry: GEOJSON_GEOMETRIES.POINT,
      styleData: {
        color: '#1dea12',
        alpha: 0.9,
        weight: 1,
        iconClass: 'paper-plane',
        pointType: POINT_TYPES.ICON,
        pointSize: 5
      }
    }
  },
  {
    name: 'Numeric Categorized',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.CATEGORIZED,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'estado',
      styleData: {
        legend: [
          {
            value: '5',
            count: 976,
            index: 1,
            color: '#7fc97f'
          },
          {
            value: '3',
            count: 545,
            index: 2,
            color: '#9bb5a5'
          },
          {
            value: '1',
            count: 97,
            index: 3,
            color: '#666666'
          }
        ],
        colorRange: 'Accent',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'Paro en España por Provincias Discreto',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.NUMERIC,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'paro',
      numIntervals: 5,
      dataLimits: [1, 21.4, 41.8, 62.2, 82.6, 100],
      styleData: {
        legend: [
          {
            value: '1 - 21.4',
            count: 10,
            index: 1,
            color: '#fff7fb'
          },
          {
            value: '21.4 - 41.8',
            count: 10,
            index: 2,
            color: '#d0d1e6'
          },
          {
            value: '41.8 - 62.2',
            count: 10,
            index: 3,
            color: '#74a9cf'
          },
          {
            value: '62.2 - 82.6',
            count: 10,
            index: 4,
            color: '#0570b0'
          },
          {
            value: '82.6 - 100',
            count: 12,
            index: 5,
            color: '#023858'
          }
        ],
        colorRange: 'PuBu',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'Limpieza por Distritos 2018',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.NUMERIC,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'kg_recogida_total_2018',
      numIntervals: 4,
      dataLimits: [748419.44, 1313378.6, 1923930.9, 2704265.8, 4475942],
      styleData: {
        legend: [
          {
            value: '748419.44 - 1313378.6',
            count: 9,
            index: 1,
            color: '#fff7fb'
          },
          {
            value: '1313378.6 - 1923930.9',
            count: 6,
            index: 2,
            color: '#b4c4df'
          },
          {
            value: '1923930.9 - 2704265.8',
            count: 5,
            index: 3,
            color: '#2685bb'
          },
          {
            value: '2704265.8 - 4475942',
            count: 1,
            index: 4,
            color: '#023858'
          }
        ],
        colorRange: 'PuBu',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'Limpieza por Distritos 2017',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.NUMERIC,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'kg_recogida_total_2017',
      numIntervals: 4,
      dataLimits: [549258.6, 2076612.6, 2882676.5, 4394544, 6075992.5],
      styleData: {
        legend: [
          {
            value: '549258.6 - 2076612.6',
            count: 4,
            index: 1,
            color: '#fff5f0'
          },
          {
            value: '2076612.6 - 2882676.5',
            count: 9,
            index: 2,
            color: '#fca082'
          },
          {
            value: '2882676.5 - 4394544',
            count: 4,
            index: 3,
            color: '#e32f27'
          },
          {
            value: '4394544 - 6075992.5',
            count: 4,
            index: 4,
            color: '#67000d'
          }
        ],
        colorRange: 'Reds',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'Incremento Recogida',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.NUMERIC,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'incr_recog',
      numIntervals: 4,
      dataLimits: [-2882100.5, -1434772.8, -899059.56, -601050.25, 239138.88],
      styleData: {
        legend: [
          {
            value: '-2882100.5 - -1434772.8',
            count: 2,
            index: 1,
            color: '#a50026'
          },
          {
            value: '-1434772.8 - -899059.56',
            count: 4,
            index: 2,
            color: '#fdbf71'
          },
          {
            value: '-899059.56 - -601050.25',
            count: 10,
            index: 3,
            color: '#bde2ee'
          },
          {
            value: '-601050.25 - 239138.88',
            count: 5,
            index: 4,
            color: '#313695'
          }
        ],
        colorRange: 'RdYlBu',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'Servicios Limpieza 2018',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.NUMERIC,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'n_servicios_total_2018',
      numIntervals: 4,
      dataLimits: [3827, 7997, 10552, 11841, 30127],
      styleData: {
        legend: [
          {
            value: '3827 - 7997',
            count: 10,
            index: 1,
            color: '#fff7fb'
          },
          {
            value: '7997 - 10552',
            count: 9,
            index: 2,
            color: '#b4c4df'
          },
          {
            value: '10552 - 11841',
            count: 1,
            index: 3,
            color: '#2685bb'
          },
          {
            value: '11841 - 30127',
            count: 1,
            index: 4,
            color: '#023858'
          }
        ],
        colorRange: 'PuBu',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'Servicios Limpieza 2017',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.NUMERIC,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'n_servicios_total_2017',
      numIntervals: 4,
      dataLimits: [3509, 9210, 10646, 12997, 30956],
      styleData: {
        legend: [
          {
            value: '3509 - 9210',
            count: 9,
            index: 1,
            color: '#fff5f0'
          },
          {
            value: '9210 - 10646',
            count: 10,
            index: 2,
            color: '#fca082'
          },
          {
            value: '10646 - 12997',
            count: 1,
            index: 3,
            color: '#e32f27'
          },
          {
            value: '12997 - 30956',
            count: 1,
            index: 4,
            color: '#67000d'
          }
        ],
        colorRange: 'Reds',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'Incremento Servicios',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.NUMERIC,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'incr_num_servic',
      numIntervals: 4,
      dataLimits: [-4465.022, -1866, -47, 1110, 1664],
      styleData: {
        legend: [
          {
            value: '-4465.022 - -1866',
            count: 2,
            index: 1,
            color: '#a50026'
          },
          {
            value: '-1866 - -47',
            count: 4,
            index: 2,
            color: '#fdbf6f'
          },
          {
            value: '-47 - 1110',
            count: 5,
            index: 3,
            color: '#b7e075'
          },
          {
            value: '1110 - 1664',
            count: 10,
            index: 4,
            color: '#006837'
          }
        ],
        colorRange: 'RdYlGn',
        weight: 1,
        alpha: 0.9
      }
    }
  },
  {
    name: 'GeoJSON VT',
    styleType: STYLE_TYPES.GEOJSON,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.CATEGORIZED,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      propName: 'cod_ccaa',
      styleData: {
        legend: [
          { value: '03', count: 1, index: 1, color: '#e41a1c' },
          { value: '18', count: 1, index: 2, color: '#974661' },
          { value: '11', count: 4, index: 3, color: '#4a73a7' },
          { value: '08', count: 4, index: 4, color: '#3e8e93' },
          { value: '04', count: 2, index: 5, color: '#48a462' },
          { value: '05', count: 1, index: 6, color: '#5e995e' },
          { value: '01', count: 8, index: 7, color: '#7f6e85' },
          { value: '15', count: 1, index: 8, color: '#a35391' },
          { value: '06', count: 5, index: 9, color: '#d16948' },
          { value: '07', count: 9, index: 10, color: '#ff7f00' },
          { value: '17', count: 3, index: 11, color: '#ffb817' },
          { value: '10', count: 2, index: 12, color: '#fff12d' },
          { value: '19', count: 3, index: 13, color: '#e1c72f' },
          { value: '02', count: 3, index: 14, color: '#ba7c2a' },
          { value: '12', count: 1, index: 15, color: '#b8604a' },
          { value: '16', count: 1, index: 16, color: '#dc738d' },
          { value: '09', count: 1, index: 17, color: '#ed84bb' },
          { value: '13', count: 1, index: 18, color: '#c38eaa' },
          { value: '14', count: 1, index: 19, color: '#999999' }
        ],
        colorRange: 'Set1',
        weight: 1,
        alpha: 0.9
      },
      tolerance: 100
    }
  },
  {
    name: 'MapBox',
    styleType: STYLE_TYPES.MAPBOX,
    geojsonStyle: {
      type: SYMBOLOGY_TYPES.SINGLE,
      geometry: GEOJSON_GEOMETRIES.POLYGON,
      styleData: {
        color: '#ea6512',
        weight: 1,
        alpha: 0.9
      },
      tolerance: 99999
    }
  }
];
